// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"MainLayout_contentWrapper__afanO","content":"MainLayout_content__1ROED"};